const IDLE = 'IDLE'
const FOCUS = 'FOCUS'
const VALID = 'VALID'
const VISIBLE = 'VISIBLE'

export { IDLE, FOCUS, VALID, VISIBLE }
